<template>
  <div class="pc_footer">
    <div class="footer-container">
      <div class="list">
        <span class="menu" @click="intoContent('about_us')">链接</span><span class="line">|</span>
        <span class="menu" @click="intoContent('contact_us')">中国贸促会</span><span class="line">|</span>
        <span class="menu" @click="intoContent('join_us')">13+2贸促会</span><span class="line">|</span>
        <span class="menu" @click="intoContent('disclaimer')">成员单位</span><span class="line">|</span>
        <span class="menu" @click="intoContent('terms_of_service')">陆海优品电商平台</span><span class="line">|</span>
        <span class="menu" @click="intoContent('terms_of_service')">联盟外经贸综合服务数字化平台</span>
      </div>
      <el-row :gutter="10">
        <el-col :span="14">
          <div class="left">
            <div class="contact">
              <p>联系电话</p>
              <p class="number">023-67896775</p>
              <p>重庆市两江新区一带一路商务中心2号楼12层</p>
            </div>
            <div class="text">陆海新通道国际工商会联盟 版权所有</div>
            <div class="text">
              ICP备案： <a target="_blank" href="https://beian.miit.gov.cn">渝ICP备12002785号-1</a>
              渝公网安备号： <a target="_blank" href="https://beian.miit.gov.cn">50010502504531</a>
            </div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="right">
            <div class="code">
              <img src="../../assets/img/wxcode.png" alt="" style="width: 100%">
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  computed: {
    websiteConfig: {
      get () {
        return this.$store.state.common.websiteConfig
      },
      set (val) {
        this.$store.commit('common/updateWebsiteConfig', val)
      }
    }
  },
  watch: {
  },
  mounted () {},
  methods: {
    intoContent (type) {
      // const routeUrl = this.$router.resolve({
      //   path: '/websiteContent',
      //   query: {contentType: type}
      // })
      // window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang="scss">
.footer_class{
    min-width: 80px;
    padding: 0;
  }
</style>

<style lang="scss" scoped>
.pc_footer{
  width: 100%;
  background: #262a2e;
  .footer-container {
    width: 1200px;
    margin: auto;
    padding: 30px 0;
    .list{
      font-size: 12px;
      color: #ccc;
      margin: auto;
      text-align: center;
      .menu{
        cursor: pointer;
      }
      .menu:hover{
        color: #1d74ff;
      }
      .line{
        margin:  0 8px;
        color: #777;
      }
    }
    .left {
      color: #fff;

      .contact{
        margin: 20px 0;
        font-size: 14px;
        color: #fff;
        .number{
          font-size: 20px;
          margin: 6px 0;
          color: #fff;
        }
      }
      .text{
        // margin-top: 20px;
        line-height: 18px;
        font-size: 12px;
        color: #777;
        a{
          color: #999;
        }
        a:hover{
          color: #1d74ff;
        }
      }
    }
    .right {
      display: flex;
      justify-content: center;
      padding-top: 25px;
      .code {
        img {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/footer.vue